<template>
  <button
    class="btn mb-0 mbr-btn"
    :class="getClasses(variant, color, size, fullWidth, active)"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "MaterialButton",
  props: {
    color: {
      type: String,
      default: "success",
    },
    size: {
      type: String,
      default: "md",
    },
    variant: {
      type: String,
      default: "fill",
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getClasses: (variant, color, size, fullWidth, active) => {
      let variantValue, colorValue, sizeValue, fullWidthValue, activeValue;

      // Heritage Hearth has no gradients: "gradient" renders like "fill"
      variantValue = variant === "outline" ? "mbr-btn--outline" : "mbr-btn--fill";

      colorValue = color === "danger" ? "mbr-btn--danger" : null;

      sizeValue = size ? `mbr-btn--${size}` : null;

      fullWidthValue = fullWidth ? `w-100` : null;

      activeValue = active ? `active` : null;

      return `${variantValue} ${colorValue} ${sizeValue} ${fullWidthValue} ${activeValue}`;
    },
  },
};
</script>

<style scoped>
/* !important beats the global `.btn { color: #000 !important }` in custom.css */
.mbr-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--mbr-space-sm);
  height: 44px;
  padding: 0 22px;
  border: 1px solid transparent;
  border-radius: var(--mbr-radius-full);
  font-family: var(--mbr-font-headline);
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.01em;
  text-transform: none;
  box-shadow: var(--mbr-shadow-card);
  transition: transform 0.15s ease, background-color 0.15s ease;
}

.mbr-btn--lg {
  height: 56px;
  padding: 0 28px;
  font-size: 16px;
}

.mbr-btn--sm {
  height: 36px;
  padding: 0 16px;
  font-size: 13px;
}

.mbr-btn--fill {
  background: var(--mbr-color-primary);
  color: var(--mbr-color-on-primary) !important;
}

.mbr-btn--fill.mbr-btn--danger {
  background: var(--mbr-color-error);
  color: var(--mbr-color-surface) !important;
}

/* Views mark the dismiss button of a pair with Bootstrap's btn-secondary */
.mbr-btn--outline,
.mbr-btn.btn-secondary {
  background: var(--mbr-color-surface);
  border-color: var(--mbr-color-outline);
  color: var(--mbr-color-ink-headline) !important;
  box-shadow: none;
}

.mbr-btn--outline.mbr-btn--danger {
  border-color: var(--mbr-color-error);
  color: var(--mbr-color-error) !important;
}

.mbr-btn:hover,
.mbr-btn:focus {
  box-shadow: var(--mbr-shadow-card);
}

.mbr-btn--outline:hover,
.mbr-btn--outline:focus,
.mbr-btn.btn-secondary:hover,
.mbr-btn.btn-secondary:focus {
  box-shadow: none;
}

.mbr-btn:active,
.mbr-btn:active:focus,
.mbr-btn:active:hover {
  opacity: 1;
  transform: scale(0.98);
}

.mbr-btn--outline:active,
.mbr-btn.btn-secondary:active {
  background: var(--mbr-color-tint);
}

.mbr-btn:focus-visible {
  outline: 2px solid var(--mbr-color-primary);
  outline-offset: 2px;
}

.mbr-btn:disabled,
.mbr-btn.disabled {
  opacity: 0.5;
  box-shadow: none;
  transform: none;
}
</style>
